/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type legendCardQueryVariables = {|
  corpoRef: string
|};
export type legendCardQueryResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?any,
      +plans: ?$ReadOnlyArray<?any>,
    |}
  |}
|};
export type legendCardQuery = {|
  variables: legendCardQueryVariables,
  response: legendCardQueryResponse,
|};
*/


/*
query legendCardQuery(
  $corpoRef: String!
) {
  payment {
    corpo {
      res: getSubscription(corpoRef: $corpoRef)
      plans: getPlans
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpoRef"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentQuery",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoQuery",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "corpoRef",
                "variableName": "corpoRef"
              }
            ],
            "kind": "ScalarField",
            "name": "getSubscription",
            "storageKey": null
          },
          {
            "alias": "plans",
            "args": null,
            "kind": "ScalarField",
            "name": "getPlans",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "legendCardQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "legendCardQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "90663069c95cdb8627a9fffe36cee8f4",
    "id": null,
    "metadata": {},
    "name": "legendCardQuery",
    "operationKind": "query",
    "text": "query legendCardQuery(\n  $corpoRef: String!\n) {\n  payment {\n    corpo {\n      res: getSubscription(corpoRef: $corpoRef)\n      plans: getPlans\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '440ae360a01c1e89b04cbadd8e1e435b';

module.exports = node;
